'use client';

import { useQuery } from '@/lib/convex';
import { api } from '@/convex/_generated/api';
import { getPlatformBannerToneClasses } from './platform-banner-styles';
import { usePathname } from 'next/navigation';

const HIDDEN_PREFIXES = [
  '/pricing',
  '/terms',
  '/privacy',
  '/contact',
  '/onboarding',
];

function isPlatformRoute(pathname: string): boolean {
  return !HIDDEN_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

export function ModelProviderIncidentNotice() {
  const pathname = usePathname();
  const { data: siteSettings } = useQuery(
    api.site_settings.queries.getSiteSettings
  );

  if (
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1')
  ) {
    return null;
  }

  if (!isPlatformRoute(pathname)) {
    return null;
  }

  const banner = siteSettings?.platformBanner;
  if (!banner?.enabled || !banner.message.trim()) {
    return null;
  }

  const toneClasses = getPlatformBannerToneClasses(banner.tone);

  return (
    <div
      className={`sticky top-0 z-40 w-full border-b ${toneClasses}`}
      role="status"
      aria-live="polite"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-center px-4 py-2.5 text-center text-sm font-medium">
        {banner.message}
      </div>
    </div>
  );
}
